import React from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';
import { IconButton } from '@ui/buttons/IconButton';
import { deleteTrigger } from '@services/triggers';
import { showErrorBanner } from '@utils/application';
import { formatCreatedAt } from '@utils/formatters';
import { useDispatch } from 'react-redux';
import {
  TYPE_LABEL,
  TRIGGER_LIST_GRID_COLUMNS,
  getTagLabel,
  getAgentLabel,
  getAllowConcurrencyLabel,
  getUserIdLabel,
} from './triggerListHelpers';

const Row = styled.div`
  display: grid;
  grid-template-columns: ${TRIGGER_LIST_GRID_COLUMNS};
  gap: 12px;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }
`;

const TruncateCell = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DeleteIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 20px;
    width: 20px;
  }
  path {
    fill: ${({ theme }) => theme.themeColors.text};
  }
`;

export function TriggerRow({ trigger, onDelete }) {
  const dispatch = useDispatch();

  const handleDelete = async () => {
    const { success, error } = await deleteTrigger(trigger.id);
    if (success) {
      onDelete();
    } else {
      showErrorBanner(error || 'Failed to delete trigger', null, dispatch);
    }
  };

  const typeLabel = TYPE_LABEL[trigger.trigger_type] || trigger.trigger_type;
  const tagLabel = getTagLabel(trigger);
  const agentLabel = getAgentLabel(trigger);
  const allowConcurrencyLabel = getAllowConcurrencyLabel(trigger);
  const userIdLabel = getUserIdLabel(trigger);
  const promptLabel = trigger.trigger_type === 'agent_execution' ? trigger.prompt || '—' : '—';

  return (
    <Row>
      <Body5>{typeLabel}</Body5>
      <Body5>{tagLabel}</Body5>
      <Body5>{userIdLabel}</Body5>
      <Body5>{agentLabel}</Body5>
      <Body5>{allowConcurrencyLabel}</Body5>
      <TruncateCell title={promptLabel}>
        <Body5>{promptLabel}</Body5>
      </TruncateCell>
      <Body5>{formatCreatedAt(trigger.created_at)}</Body5>
      <DeleteIconWrapper>
        <IconButton onClick={handleDelete}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z" />
          </svg>
        </IconButton>
      </DeleteIconWrapper>
    </Row>
  );
}
